import { isProduction } from './../config'

export function toConsole(msg) {
  !isProduction && console.log(msg)
}



// WEBPACK FOOTER //
// ./src/utils/logger.js